import { atom } from 'jotai';

/** AIが今まさに内容を書いているビューのID。手動チャットとMCP経由の両方をまとめて持つ。 */
export const aiWorkingViewIdsAtom = atom<string[]>([]);
